const ClausesStatus = {
    NOT_LOADED: 'Not loaded',
    LOADING: 'Loading',
    LOADED: 'Loaded',
    FAILED: 'Failed',
    TOKEN_EXPIRED: 'Token Expired',
    NO_PERMISSIONS: 'No Permissions'
};

const DocumentStatus = {
    NOT_SUBMITTED: 'Not submitted',
    INITIALIZING: 'Initializing',
    PENDING: 'Pending',
    PROCESSED: 'Processed'
};

const ScorecardStatus = {
    NOT_ANALYZED: 'NOT_ANALYZED',
    INITIALIZING: 'Initializing',
    PENDING: 'Pending',
    PROCESSED: 'Processed'
};

const ContractsStatus = {
    NOT_LOADED: 'Not loaded',
    LOADING: 'Loading',
    LOADED: 'Loaded',
    FAILED: 'Failed',
    TOKEN_EXPIRED: 'Token Expired',
    NO_PERMISSIONS: 'No Permissions'
};

export { ClausesStatus, DocumentStatus, ScorecardStatus, ContractsStatus };
